<div class="skeleton-container">
  <div *ngFor="let item of [1, 2, 3, 4, 5]" class="skeleton-item">
    <div class="skeleton-header"></div>
    <div class="skeleton-content"></div>
  </div>
</div>
